import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { DATABASE_TOOLTIPS } from 'constants/product_database/tooltips'
import { isValidValue } from 'helpers/values'
import { parseCurrency } from 'helpers/currency'
import { NoDataTooltip } from 'ui_elements/NoDataTooltip/NoDataTooltip'
import { NakedButton } from 'ui_elements/NakedButton/NakedButton'
import { Tooltip } from '@junglescout/edna'

const CalculationTextWrapper = styled.div`
  color: ${props => props.theme.colors.grey400};
  display: flex;
`

const StyledDiv = styled.div`
  display: inline-block;
  .tooltip__content {
    width: fit-content;
    white-space: nowrap;
  }
`

const InCellButton = styled(NakedButton)`
  display: inline-block;
  color: ${props => props.theme.colors.primary} !important;
`

export const Price = props => {
  const dispatch = useDispatch()
  const { product, toggleProfitCalculator, toggleFeeBreakdown } = props
  const { price, currency_code, feeBreakdown = {} } = product
  const { totalFees = 0 } = feeBreakdown
  const { t } = useTranslation(['product_database'])

  const formatPrice = () => {
    if (isValidValue(price)) return parseCurrency(price, currency_code)

    return (
      <NoDataTooltip
        content={DATABASE_TOOLTIPS.nullProductData.price}
        size="medium"
      />
    )
  }

  const formatNet = () => {
    return (
      <div>
        <Tooltip
          size="auto"
          side="bottom"
          content={
            <StyledDiv>
              {t(
                'product_database:DatabaseTable.netTooltip',
                'FBA Profit Calculator'
              )}
            </StyledDiv>
          }>
          <InCellButton
            onClick={e => {
              e.stopPropagation()
              dispatch(toggleProfitCalculator(true, product))
            }}>
            {parseCurrency(price - totalFees, currency_code)}
          </InCellButton>
        </Tooltip>
      </div>
    )
  }

  const formatFees = () => {
    if (totalFees === 0) return '--'
    return (
      <Tooltip
        size="auto"
        side="bottom"
        content={
          <div>
            {t('product_database:DatabaseTable.feesTooltip', 'Fees Breakdown')}
          </div>
        }>
        <InCellButton
          onClick={e => {
            e.stopPropagation()
            dispatch(toggleFeeBreakdown(true, product))
          }}>
          {parseCurrency(totalFees, currency_code)}
        </InCellButton>
      </Tooltip>
    )
  }

  const formatNetAndFees = () => {
    if (!isValidValue(price) && !isValidValue(feeBreakdown)) {
      return null
    }

    if (!isValidValue(price)) {
      return (
        <NoDataTooltip
          content={DATABASE_TOOLTIPS.nullProductData.noPriceNet}
          size="medium"
        />
      )
    }

    if (!isValidValue(feeBreakdown)) {
      return (
        <NoDataTooltip
          content={DATABASE_TOOLTIPS.nullProductData.noFeesNet}
          size="medium"
        />
      )
    }

    return (
      <>
        ({formatNet()}
        <span>&nbsp;|&nbsp;</span>
        {formatFees()})
      </>
    )
  }

  return (
    <>
      {formatPrice()}
      <CalculationTextWrapper>{formatNetAndFees()}</CalculationTextWrapper>
    </>
  )
}

Price.propTypes = {
  product: PropTypes.PropTypes.objectOf(PropTypes.any).isRequired,
  toggleProfitCalculator: PropTypes.func.isRequired,
  toggleFeeBreakdown: PropTypes.func.isRequired
}
